// extracted by mini-css-extract-plugin
export default {"root":"ChaptersListFooter_root__l+8rA"};